export default __webpack_public_path__ + "static/media/CompletedTask.95240b04.svg";